
import * as cookie from 'cookie';
import RoutePageStore from "FF/Vue/ControlCenter/Core/RoutePageStore";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({
})
export default class SideBar extends Vue {

    @Prop({
        type: Object,
        default: function() {
            return {};
        },
    }) readonly adminSidebox!: {};
    
    @Prop({
        type: [String, Number],
        default: '',
    }) readonly urlRootPath!: string | number;
    
    @Prop({
        type: [String, Number],
        default: 0,
    }) readonly isUserLogin!: string | number;
    
    @Prop({
        type: Object,
        default: function() {
            return {};
        },
    }) readonly user!: {};
    
    @Prop({
        type: [String, Number],
        default: 0,
    }) readonly routeToLogout!: string | number;
    
    @Prop({
        type: [String, Number],
        default: null,
    }) readonly routeToLogin!: string | number;
    
    @Prop({
        type: [String, Number],
        default: '',
    }) readonly sidebarDefaultImgSrc!: string | number;
    
    @Prop({
        type: [String],
        default: '',
    }) readonly language!: string;
    
    @Prop({
        type: [String],
        default: '',
    }) readonly currentLocale!: string ;
    
    languages: {} = {};
    locale: string = "";
    isLargeScreen: boolean = false;
    headerBarCloseBgDisplay: boolean = false;
    headerBarCloseBgOpacity: boolean = true;

    get sidebarOpened() {
        return RoutePageStore.state.sidebarOpened;
    }

    set sidebarOpened( value ) {
        RoutePageStore.state.sidebarOpened = value;
    }
    
    @Watch('sidebarOpened')
    onChangeSidebarOpened()
    {
        this.toggleHeaderBarMenu();
    }
    
    onMenuClick() {
        if( this.sidebarOpened )
        {
            this.sidebarOpened = false;
        }
        else
        {
            this.sidebarOpened = true;
        }
    }
    // 根據查詢增加結果
    linkToUserCenter() {
        window.location.href = "userCenter/my/user/user/edit/view";
    }

    setRouteQuerySidebarOpened() {
        const query: {
            sidebarOpened?: string | null
        } = {
            sidebarOpened: null
        };
        
        for( let key in this.$route.query )
        {
            query[key] = this.$route.query[key];
        }
        
        if( this.sidebarOpened )
        {
            query.sidebarOpened = null;
        }
        else
        {
            delete query.sidebarOpened;
        }

        this.$router.push({
            path: this.$route.path,
            query: query
        })
        .catch((error) => {

        });
    }

    toggleHeaderBarMenu() {
        if ( this.sidebarOpened )
        {
            $(".bodyContent").addClass("sidebarOpened");

            if ($(window).width()< 768) {
                this.headerBarCloseBgDisplay = true;
                this.headerBarCloseBgOpacity = true;
                this.setRouteQuerySidebarOpened();
            }
            else
            {
                cookie.serialize( 'controlCenterSidebarOpened', true, {
                    httpOnly: true,
                    maxAge: 60 * 60 * 24 * 30
                } );
            }
        } 
        else 
        {
            $(".bodyContent").removeClass("sidebarOpened");

            if ($(window).width()< 768)
            {
                this.headerBarCloseBgOpacity = false;
                this.setRouteQuerySidebarOpened();

                setTimeout(() => {
                    if ($(".headerBarCloseBg").hasClass("opacity0")) {
                        this.headerBarCloseBgDisplay = false;
                    }
                }, 300);
            }
            else
            {
                cookie.serialize( 'controlCenterSidebarOpened', null );
            }
        }

    }

    changeLocale(event) {
        this.locale = event.target.value;
        window.location.href = `api/lang/${this.locale}`;
    }

    onClickAdminHeaderFatherAreaArrow( event ) {
        let $adminHeaderFatherArea = $(event.currentTarget).parent('.adminHeaderFatherArea');

        if ( $adminHeaderFatherArea.hasClass("hover") )
        {
            $adminHeaderFatherArea.removeClass("hover");
        } 
        else 
        {
            $(".headerBarContent .adminHeaderFatherArea").removeClass("hover");
            $adminHeaderFatherArea.addClass("hover");
        }
    }

    onWindowResize() {

        if ( $(window).width()>= 768)
        {
            this.isLargeScreen = true;
        }
        else
        {
            this.isLargeScreen = false;
        }

        this.sidebarOpened = false;
        this.toggleHeaderBarMenu();
    }

    mounted() {

        this.languages = JSON.parse(this.language);
        this.locale = this.currentLocale;

        if ($(window).width()>= 768 ) {
            this.isLargeScreen = true;
        }

        this.$router.afterEach( ( to, from ) => {
            if( to.query.sidebarOpened !== undefined )
            {
                this.sidebarOpened = true;
            }
            else
            {
                this.sidebarOpened = false;
            }
        });

        window.addEventListener('resize', this.onWindowResize, false);

        if ($(window).width()< 768) {
            $('.headerBarLeftSwipeArea').on("swiperight", (event) => {
                if ( ! this.sidebarOpened ) {
                    this.sidebarOpened = true;
                }
            });
            $('.headerBarContent.sidebarOpened').on("swipeleft", (event) => {
                if ( this.sidebarOpened ) {
                    this.sidebarOpened = false;
                }
            });
        }

    }
}
